import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=3d8156a0&scoped=true"
import script from "./LanguageToggle.vue?vue&type=script&lang=ts"
export * from "./LanguageToggle.vue?vue&type=script&lang=ts"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=3d8156a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8156a0",
  null
  
)

export default component.exports